import {LightWeightApplication, lightWeightApplicationSchema} from "../Application";
import {TFunction} from "i18next";
import {number, object, ObjectSchema, string} from "yup";
import {fieldDefinedError} from "../../../shared/technical/rest/validation";
import {LightweightUser} from "../../users/User";
import {EntityRef} from "../../../shared/technical/rest/entities";

export interface ApplicationUserGroup {
  id?: string,
  name: string,
  application: LightWeightApplication,
  amountOfUsers?: number
}

export interface ApplicationUserGroupMembership {
  id?: string,
  user: LightweightUser
}

export interface CreateApplicationUserGroupMembership {
  user: EntityRef
}

export function applicationUserGroupSchema(t: TFunction): ObjectSchema<ApplicationUserGroup> {
  return object({
    id: string(),
    name: string().trim().required(fieldDefinedError(t)),
    application: lightWeightApplicationSchema,
    amountOfUsers: number()
  })
}

export function defaultApplicationUserGroup(application: LightWeightApplication, t: TFunction) {
  return {...applicationUserGroupSchema(t).getDefault(), application: application} as ApplicationUserGroup
}
